import { useQuery } from "@apollo/client";
import { IonContent } from "@ionic/react";
import { useCallback, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";
import { useHistory } from "react-router";

import AutomationForm from "@components/forms/AutomationForm";
import HandleQuery from "@components/HandleQuery";
import AppPage from "@components/pageTypes/AppPage";
import { GetAutomationDocument, GetAutomationQuery, GetAutomationQueryVariables } from "@typing/Generated";

type Props = {
  automationId: string;
};

const ExpertAutomationEditPage = ({ automationId }: Props) => {
  const history = useHistory();
  const intl = useIntl();
  const contentRef = useRef<HTMLIonContentElement>(null);

  const getAutomationQuery = useQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, {
    variables: {
      id: automationId
    }
  });

  const handleFormSuccessOrCancel = useCallback(() => {
    history.push(`/expert/automations/${automationId}`);
  }, [automationId, history]);

  const handleFormError = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollToTop(2000);
    }
  }, [contentRef]);

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: "pageTitles.expert.automation.edit" })}</title>
      </Helmet>
      <IonContent className="ion-padding" ref={contentRef}>
        <HandleQuery query={getAutomationQuery}>
          {data => (
            <AutomationForm
              autofocus
              automation={data.automation}
              onCancel={handleFormSuccessOrCancel}
              onError={handleFormError}
              onSuccess={handleFormSuccessOrCancel}
            />
          )}
        </HandleQuery>
      </IonContent>
    </AppPage>
  );
};

export default ExpertAutomationEditPage;
